// extracted by mini-css-extract-plugin
export var container = "_mp-0";